var map = {
	"./a-new-petrochemical-and-oil-refinery-plant-have-to-be-established-soon.mp4": 2372,
	"./bse-site-location.mp4": 7620,
	"./compacting-highway-road.mp4": 2930,
	"./plan-project.mp4": 4174,
	"./sitelocation.mp4": 9567,
	"./trase-asphalt-sumbersih-on-working.mp4": 3855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1030;